import axios from '@/utils/request';
const prefix = process.env.VUE_APP_API_PREFIX_1;
const baseOriginURL = `${prefix}/message`;

// 获取消息列表
const GetMessageList = (params, hideLoading = false) => {
  return axios.request({
    method: 'get',
    url: `${baseOriginURL}/GetMessageList`,
    params,
    headers: {
      hideLoading
    }
  });
};

// 获取消息详情
const GetMessageDetail = params => {
  return axios.get(`${baseOriginURL}/GetMessageDetail`, { params });
};

// 已读消息
const ReadMessage = data => {
  return axios.post(`${baseOriginURL}/ReadMessage`, data);
};

// 已读全部消息
const ReadAllMessage = data => {
  return axios.put(`${baseOriginURL}/ReadAllMessage`, data);
};

// 获取自己发送消息列表
const GetMySendMessage = params => {
  return axios.get(`${baseOriginURL}/GetMySendMessage`, { params });
};

// 发送消息
const SendMessage = data => {
  return axios.post(`${baseOriginURL}/SendMessage`, data);
};

// 删除消息
const DeleteMessage = data => {
  return axios.delete(`${baseOriginURL}/DeleteMessage`, data);
};

// 删除全部消息
const DeleteAllMessage = data => {
  return axios.delete(`${baseOriginURL}/DeleteAllMessage`, data);
};

export {
  GetMessageList,
  GetMessageDetail,
  ReadMessage,
  ReadAllMessage,
  GetMySendMessage,
  SendMessage,
  DeleteMessage,
  DeleteAllMessage,
};
